<div class="app-titulo-pagina-v2">
    <img src="../../../assets/img/icons/bt_sac.png" alt="Icone btn_sac">
    <span>SAC -Novo Chamado
    </span>
</div>
<div class="container">
    <div *ngIf="processando"
         class="text-center">
        <i class="fa fa-spinner fa-pulse fa-4x"></i>
    </div>

    <form *ngIf="!processando"
          ngNativeValidate
          (submit)="saveChamado()"
          class="col-xs-12 col-md-12">
        <div class="panel-body">
            <div class="form-group">
                <label for="assunto">Assunto</label>
                <input type="text" id="assunto"
                       required
                       name="assunto"
                       [(ngModel)]="chamado.assunto"
                       class="form-control input-sm" maxlength="256">
            </div>
            <div class="form-group">
                <label for="mensagem">Mensagem</label>
                <textarea style="resize: none;" id="mensagem"
                          required
                          name="mensagens"
                          [(ngModel)]="chamado.mensagens[0].mensagem"
                          class="form-control input-sm" rows="10"></textarea>
            </div>
            <div class="form-group">
                <label for="anexo1">Anexo 1</label>
                <input type="file" id="anexo1"
                       class="form-control input-sm"
                       (change)="formatFile($event,0)">
                <input type="hidden" id="anexo1-hidden">
            </div>
            <div class="form-group">
                <label for="anexo2">Anexo 2</label>
                <input type="file" id="anexo2"
                       class="form-control input-sm"
                       (change)="formatFile($event,1)">
                <input type="hidden" id="anexo2-hidden">
            </div>
            <div class="form-group">
                <label for="anexo3">Anexo 3</label>
                <input type="file" id="anexo3"
                       class="form-control input-sm"
                       (change)="formatFile($event,2)">
                <input type="hidden" id="anexo3-hidden">                       
            </div>
        </div>
        <div class="col-xs-12 text-center">
            <a (click)="mainService.loginService.changeRoute('sac')" 
                class="btn btn-danger-v2"
                id="btn-voltar">
                Voltar
            </a>
            <button type="submit" class="btn btn-success-v2" id="btn-salvar">
                Salvar
            </button>
        </div>
    </form>
</div>



// WEBPACK FOOTER //
// ./src/app/menu-superior/sac/form/sac-form.component.html